export const environment = {
  production: false,
  apiUrl: 'https://tax-live.nstechs.net/api',
  projectName: 'Turbo',
  projectFavIcon: '/assets/favicon/turbo.ico',
  projectIcon: '/assets/img/turbo_logo.png',
  projectLoginIcon: '/assets/img/turbo_login.gif',
  projectTheme: '/assets/css/turbo-loading.css',
  primaryColor: '#D324A6',
  primaryColorLight: '#fcd8ed',
  primaryColorDark: '#b71e90',
  backgroundGradient: 'linear-gradient(to left, #fff, #f9c5e5)'
};
